function validarCPF(cpf) {
  return true;
}

function validarCNPJ(cnpj) {
  return true;
}

export {validarCPF, validarCNPJ}